import { Accounts } from 'components/main/routes/accounts';
import { Custodians } from 'components/main/routes/custodians';
import { Investors } from 'components/main/routes/investors';
import { Issuers } from 'components/main/routes/issuers';
import { Prices } from 'components/main/routes/prices';
import { RevenueStructures } from 'components/main/routes/revenue-structures';
import { Securities } from 'components/main/routes/securities';
import { Transactions } from 'components/main/routes/transactions';
import { Users } from 'components/main/routes/users';
import { RX } from 'enums/radix';
import { RouteDef } from 'interfaces/layout/route';
import { Controllers } from 'lib/enums/routes/_controllers';

const ADMIN_ROUTES: RouteDef[] = [
  {
    label: 'Users',
    path: Controllers.users,
    element: Users,
    color: RX.CLR.ADMIN,
  },
];

const DEALER_ROUTES: RouteDef[] = [
  {
    label: 'Accounts',
    path: Controllers.accounts,
    element: Accounts,
    color: RX.CLR.DEALER,
  },
  {
    label: 'Custodians',
    path: Controllers.custodians,
    element: Custodians,
    color: RX.CLR.DEALER,
  },
  {
    label: 'Investors',
    path: Controllers.investors,
    element: Investors,
    color: RX.CLR.DEALER,
  },
  {
    label: 'Issuers',
    path: Controllers.issuers,
    element: Issuers,
    color: RX.CLR.DEALER,
  },
  {
    label: 'Prices',
    path: Controllers.prices,
    element: Prices,
    color: RX.CLR.DEALER,
  },
  {
    label: 'Revenue',
    path: Controllers.revenueStructures,
    element: RevenueStructures,
    color: RX.CLR.DEALER,
  },
  {
    label: 'Securities',
    path: Controllers.securities,
    element: Securities,
    color: RX.CLR.DEALER,
  },
  {
    label: 'Transactions',
    path: Controllers.transactions,
    element: Transactions,
    color: RX.CLR.DEALER,
  },
];

const INVESTOR_ROUTES: RouteDef[] = [
  {
    label: 'Accounts',
    path: Controllers.accounts,
    element: Accounts,
    color: RX.CLR.USER,
  },
  {
    label: 'Transactions',
    path: Controllers.transactions,
    element: Transactions,
    color: RX.CLR.USER,
  },
];

export const PATHS = {
  COMMON: {
    login: '/login',
  },

  ADMIN: ADMIN_ROUTES,
  DEALER: DEALER_ROUTES,
  INVESTOR: INVESTOR_ROUTES,
};
